/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { ClassifyProposalResponse, ClassifyProposalVars } from '../openapi-types.gen.js';

export type { ClassifyProposalResponse, ClassifyProposalVars } from '../openapi-types.gen.js';

export const useClassifyProposal = createMutationHook<ClassifyProposalVars, ClassifyProposalResponse, unknown>({
  specName: 'useClassifyProposal',
  path: '/ai/proposal/classify',
  method: 'POST',
  resolveUrl: (vars: ClassifyProposalVars) => `/ai/proposal/classify`,
  buildBody: (vars: ClassifyProposalVars) => ({ title: vars.title, description: vars.description, outcomes: vars.outcomes }),
  parseResponse: (raw: unknown): ClassifyProposalResponse => raw as ClassifyProposalResponse,
  
  
  
});
